<template>
  <v-card class="auth-content elevation-12 pa-8" max-width="612">
    <v-card-text>
      <v-row>
        <v-col cols="8">
          <div class="text-h5-nk">{{ $t('accountRecoveryInitiate.title') }}</div>
        </v-col>
        <v-col cols="4" class="text-right">
          <div class="text-subtitle-1 text-button-nk" @click="handleLoginButtonClick">{{ $t('loginForm.title') }}</div>
        </v-col>
      </v-row>
      <v-form @keyup.enter.native="handleRecovery" class="mt-5">
        <v-text-field ref="email" :errorMessages="emailErrors"
                      :disabled="progress" v-model="email"
                      name="email" :placeholder="$t('accountRecoveryInitiate.fields.email.label')" type="text"
                      autocomplete="username"
                      outlined
                      dense>
          <template slot="prepend-inner">
            <v-icon>$vuetify.icons.person</v-icon>
          </template>
        </v-text-field>
        <div v-if="!canRecoveryAccount" class="text-subtitle-1">
          {{ $t('accountRecoveryInitiate.hint.nextAttemptAfter') }}
          <attempt-guard-countdown :nextAttemptAfter=nextAttemptAfter
                                   @release="handleAttemptGuardRelease"></attempt-guard-countdown>
        </div>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-row>
        <v-col cols="12" sm="4">
          <v-btn color="light-blue-nk n700" class="white--text"
                 :loading="progress"
                 @click="handleRecoveryButtonClick"
                 :disabled="progress || !canRecoveryAccount">
            {{ $t('accountRecoveryInitiate.buttons.restore.title') }}
          </v-btn>
        </v-col>
        <v-col cols="12" sm="8">
          <div class="text-subtitle-1 text-sm-right text-center mt-1">{{ $t('accountRecoveryInitiate.description') }}</div>
        </v-col>
      </v-row>
    </v-card-actions>
  </v-card>
</template>

<script>
import _ from "lodash";
import api from '../api'
import {extractUserErrorMessage, extractValidationErrors} from 'js-core/helpers/api'
import AttemptGuardCountdown from '../components/common/AttemptGuardCountdown'

export default {
  name: "AccountRecovery",
  components: {
    AttemptGuardCountdown
  },
  data() {
    return {
      progress: false,
      email: null,
      validationErrors: {},
      nextAttemptAfter: null
    }
  },
  computed: {
    emailErrors() {
      return _.get(this.validationErrors, 'email', null)
    },
    canRecoveryAccount() {
      return this.nextAttemptAfter === null
    }
  },
  methods: {
    async handleRecoveryButtonClick() {
      await this.handleRecovery()
    },
    async handleRecovery() {
      this.validationErrors = {}
      this.progress = true

      try {
        let result = await api.initiateAccountRecovery(this.email, this.$i18n.locale)
        this.nextAttemptAfter = _.get(result, 'nextAttemptAfter', null)

        this.$snotify.success(this.$i18n.t("accountRecoveryInitiate.events.emailSentSuccess"))
      } catch (e) {
        this.validationErrors = extractValidationErrors(e)

        if (this.validationErrors === null) {
          this.$snotify.error(extractUserErrorMessage(e, this.$i18n.t("accountRecoveryInitiate.errors.unableRecovery")))
        }
      }

      this.progress = false
    },
    handleAttemptGuardRelease() {
      this.nextAttemptAfter = null
    },
    handleLoginButtonClick() {
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>

</style>